import { Injectable } from '@angular/core';
import { _Service } from './_service';
import { NewsSource } from '../../model';

@Injectable({ providedIn: 'root' })
export class NewsSourceService extends _Service<NewsSource> {
  constructor() {
    super('api/news-source');
  }
}
